import { ActionTree } from 'vuex'
import { State } from '.'
import { Languages } from '@/enums'

const actions: ActionTree<State, any> = {
	setUserAge({ state, commit }, payload: '<23' | '23+') {
		commit('setUserAge', payload)
	},
	setUserPreferredBranches({ state, commit }, payload: [string, string?, string?] | 'skipped' | false) {
		commit('setUserPreferredBranches', payload)
	},
	setCriminalRecord({ state, commit }, payload: 'yes' | 'no') {
		commit('setCriminalRecord', payload)
	},
	setSelectedCrime({ state, commit }, payload: string) {
		if (state.user.selectedCrime !== payload) {
			commit('setSelectedPunishment', false)
			commit('setCrimeWhen', false)
			commit('setPunishmentWhen', false)
			commit('setPunishmentLength', false)
		}

		commit('setSelectedCrime', payload)
	},
	setSelectedPunishment({ state, commit }, payload: string) {
		if (state.user.selectedPunishment !== payload) {
			commit('setCrimeWhen', false)
			commit('setPunishmentWhen', false)
			commit('setPunishmentLength', false)
		}

		commit('setSelectedPunishment', payload)
	},
	setCrimeWhen({ state, commit }, payload: { day: number, month: number, year: number } | 'skipped' | false) {
		commit('setCrimeWhen', payload)
	},
	setPunishmentWhen({ state, commit }, payload: { day: number, month: number, year: number } | 'skipped' | false) {
		commit('setPunishmentWhen', payload)
	},
	setPunishmentLength({ state, commit }, payload: { amount: number, timeNotation: string } | 'skipped' | false) {
		commit('setPunishmentLength', payload)
	},
	resetUser({ state, commit }) {
		commit('resetUser')
		commit('setTrackResults', true)
	},
	trackResults({ state, commit }) {
		if (state.trackResults) {
			_paq.push(['trackEvent', 'GebruikerBericht', 'applicatieVolledigDoorlopen'])
		}
		
		commit('setTrackResults', false)
	},
	setLanguage({ state, commit }, payload: Languages) {
		commit('setLanguage', payload)
	}
}

export default actions
